import styled from 'styled-components';

const AccountStyles = styled.section`
  position: relative;
  padding: 50px 0px;
  height: 100%;
  .loading-screen {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .container {
    position: relative;
    max-width: 1108px;
    padding: 0px 25px;
    margin: 0 auto;
  }
  .DXContactCard-item-list {
    a,
    address {
      text-decoration: none;
      font-style: normal;
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #4e5255;
    }
  }
  h1 {
    margin-bottom: 50px;
  }
  h4 {
    border-bottom: 1px solid #c3c3c3;
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    position: relative;
    .left {
      flex: 1 1 65%;
    }
    .right {
      flex: 0 0 35%;
      padding: 0px 0px 0px 30px;
    }
  }
  .items {
    position: relative;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    .text {
      flex: 1 1 48%;
      padding: 10px 0px;
      border-bottom: 1px solid #c3c3c3;
      display: flex;
    }
  }
  .account-wrap {
    position: relative;
    width: 100%;
  }
  .account-left {
    flex: 1 1 100%;
  }
  .account-right {
    flex: 1 0 auto;
    max-width: 290px;
  }
  .flex-half {
    position: relative;
    display: flex;
    gap: 30px;
  }
  .DXPortal {
    z-index: 6;
  }
  .DXTextInput {
    flex: 0 1 326px;
    margin-bottom: 20px;
    .DXTextInput-input {
      font-size: 14px;
      font-weight: 300;
      font-family: 'source-sans-pro', sans-serif;
    }
    .DXTextInput-label {
      font-size: 14px;
      line-height: 22px;
    }
  }
  .account-left .account-input-header {
    margin-bottom: 20px;
    display: flex;
  }
  .notification-settings-stack {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .preferred-method-list {
    position: relative;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 1028px) {
    .flex-half {
      gap: 0px;
      flex-wrap: wrap;
    }
    .DXTextInput {
      flex: 0 0 100%;
    }
    .preferred-method-list,
    .preferred-time-list {
      flex-wrap: wrap;
      justify-content: start;
    }
  }
  @media only screen and (max-width: 600px) {
    .preferred-method-list,
    .preferred-time-list {
      .DXCheckbox {
        width: 100%;
      }
    }
  }
`;

export default AccountStyles;
